var n = /* @__PURE__ */ ((r) => (r.IDLE = "idle", r.PROCESSING = "processing", r.REQUIRES_ACTION = "requires_action", r.REDIRECTING = "redirecting", r.VERIFYING = "verifying", r.SUCCEEDED = "succeeded", r.FAILED = "failed", r))(n || {});
const d = {
  kind: "idle"
  /* IDLE */
};
function i(r) {
  return r.kind === "succeeded" || r.kind === "failed";
}
function c(r) {
  return r.kind === "processing" || r.kind === "requires_action" || r.kind === "redirecting" || r.kind === "verifying";
}
function E(r, e = !1) {
  return e && r.kind === "succeeded" ? !0 : c(r) && r.kind !== "requires_action";
}
function o(r, e) {
  switch (e.type) {
    // SUBMIT_* represent an explicit user action that starts a fresh attempt,
    // so they may restart the machine from any state (including a previous
    // terminal one — e.g. retry after a failure). Re-entrancy while a payment
    // is already in flight is prevented by the caller's submit guard, not here.
    case "SUBMIT_INLINE":
      return {
        kind: "processing"
        /* PROCESSING */
      };
    case "SUBMIT_REDIRECT":
      return {
        kind: "redirecting"
        /* REDIRECTING */
      };
    // An inline engine started/finished showing a challenge on its mount. These
    // only toggle the PROCESSING<->REQUIRES_ACTION pair; from any other state
    // (e.g. a terminal result already landed, or a stale late signal) they are
    // no-ops, so they can never resurrect or clobber the machine.
    case "REQUIRES_ACTION":
      return r.kind === "processing" ? {
        kind: "requires_action"
        /* REQUIRES_ACTION */
      } : r;
    case "ACTION_RESOLVED":
      return r.kind === "requires_action" ? {
        kind: "processing"
        /* PROCESSING */
      } : r;
    case "VERIFY_STARTED":
      return r.kind === "idle" ? { kind: "verifying", orderId: e.orderId } : r;
    case "SUCCEEDED":
      return i(r) ? r : {
        kind: "succeeded",
        payment: e.payment,
        orderId: e.orderId
      };
    case "FAILED":
      return i(r) ? r : {
        kind: "failed",
        error: e.error,
        orderId: e.orderId
      };
    case "RESET":
      return d;
    default:
      return r;
  }
}
export {
  d as IDLE_PAYMENT_STATUS,
  n as PaymentStatusKind,
  c as isInFlight,
  i as isTerminal,
  o as paymentStatusReducer,
  E as shouldShowProcessingOverlay
};
//# sourceMappingURL=paymentStatus.js.map
